function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useState, useCallback, useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { mergeProject, hideModal } from '../../redux/actions';
import { isEmpty, noop } from 'lodash/fp';
import text from '../../text';
import { Button } from '../button';
import ProjectSelect from '../select/ProjectSelect/ProjectSelect';
import IconWithTooltip from '../icon/IconWithTooltip';
import { isAdministrator } from '../../utilities/user';
import { getProjectName } from '../../utilities/project';
export var MERGE_PROJECT_MODAL = 'MERGE_PROJECT_MODAL';
var MergeProjectModal = function(param) {
    var show = param.show, currentJob = param.currentJob, _param_onSuccess = param.onSuccess, onSuccess = _param_onSuccess === void 0 ? noop : _param_onSuccess;
    var dispatch = useDispatch();
    var currentUser = useSelector(function(state) {
        return {
            currentUser: state.profileReducer.userProfile
        };
    }).currentUser;
    var _useState = _sliced_to_array(useState(), 2), targetProject = _useState[0], setTargetProject = _useState[1];
    var onHide = function() {
        return dispatch(hideModal(MERGE_PROJECT_MODAL));
    };
    var onOk = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(event) {
            var isMerged;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        if (!!isEmpty(currentJob)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            dispatch(mergeProject(currentJob.project, targetProject))
                        ];
                    case 1:
                        isMerged = _state.sent();
                        onHide();
                        if (isMerged) {
                            onSuccess(targetProject);
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        currentJob,
        targetProject
    ]);
    var projectFilter = function(job) {
        return function(option) {
            return option && (job === null || job === void 0 ? void 0 : job.project) && option.id !== job.project.id;
        };
    };
    var isMergeEnabled = useMemo(function() {
        return targetProject && targetProject.id && (currentJob === null || currentJob === void 0 ? void 0 : currentJob.project.id);
    }, [
        targetProject,
        currentJob
    ]);
    return /*#__PURE__*/ React.createElement(Modal, {
        centered: true,
        show: show,
        onHide: onHide
    }, /*#__PURE__*/ React.createElement(Modal.Header, {
        className: "justify-content-start",
        closeButton: true
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "mr-1 green-1"
    }, text('mergeProjects')), /*#__PURE__*/ React.createElement(IconWithTooltip, {
        icon: "information",
        tooltipText: text('mergeProjectsInfo')
    })), /*#__PURE__*/ React.createElement(Modal.Body, {
        className: "p-0 pt-3 pb-3"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "mb-3"
    }, text('selectProjectToMerge', {
        projectName: getProjectName(currentJob === null || currentJob === void 0 ? void 0 : currentJob.project)
    })), /*#__PURE__*/ React.createElement(ProjectSelect, {
        className: "mb-3",
        filterPredicate: function(option) {
            return projectFilter(currentJob)(option);
        },
        onChange: function(option) {
            return setTargetProject(option);
        },
        isCreateOptionEnabled: false,
        isAdmin: isAdministrator(currentUser.role)
    }), /*#__PURE__*/ React.createElement("p", {
        className: "mb-0"
    }, text('mergeProjectNote', {
        projectName: getProjectName(currentJob === null || currentJob === void 0 ? void 0 : currentJob.project)
    }))), /*#__PURE__*/ React.createElement(Modal.Footer, {
        className: "p-0 pb-3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-100 d-flex flex-column"
    }, /*#__PURE__*/ React.createElement(Button, {
        className: "full-width mb-3",
        disabled: !isMergeEnabled,
        onClick: onOk
    }, text('merge')), /*#__PURE__*/ React.createElement(Button, {
        className: "full-width",
        variant: "outline-primary",
        onClick: onHide
    }, text('cancel')))));
};
export default MergeProjectModal;
